import React, {Component} from 'react';
import {FaIcon} from "../../../FaIcon";
import AddNoteModal from "./AddNoteModal";
import {APIClient} from "../../../../utils/APIClient";
import { withTranslation } from 'react-i18next';

class LeadNotesSection extends Component {
    constructor(props) {
        super(props);

        this.handleAddNoteSubmit = this.handleAddNoteSubmit.bind(this);
    }

    handleAddNoteSubmit(noteText) {
        this.submitNewNote(noteText)
    }

    submitNewNote(noteText) {
        const { t } = this.props;
        const noteUrl = `${this.props.crmApiURL}/lead/${this.props.leadId}/notes`;
        const addNoteRequest = new APIClient(noteUrl).call('POST', {note: noteText});
        addNoteRequest.then((response) => {
            if (response.status === 'ERROR') {
                alert(t('lead_detail.notes_loading_error'));
            } else {
                this.props.onNoteAdd(response.data)
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="notes">
                <div className="notes-header">
                    <h3 className="note-title"><FaIcon iconName="envelope"/>{t('lead_detail.notes')}</h3>
                    <AddNoteModal onSubmit={this.handleAddNoteSubmit} leadId={this.props.leadId}/>
                </div>
                {this.renderNotes()}
            </div>
        )
    }

    renderNotes() {
        const noteItems = this.props.leadData.notes.map(note => {

            return this.renderNoteItem(note)
        });
        return <ul className="notes-list">{noteItems}</ul>
    }

    renderNoteItem(note) {
        return <li key={note.id} className="note-item">
            <p className="note-date">{note.date}</p>
            <p>{note.text}</p>
        </li>;
    }


}

export default withTranslation()(LeadNotesSection);